import { StandardEvents, CartLinesUpdateEvent } from '@shopify/events';
import { QuantitySelectorUpdateEvent } from '@theme/events';

const money = (amount, element) => new Intl.NumberFormat(element.dataset.locale || document.documentElement.lang, {style:'currency', currency:element.dataset.currency}).format(amount / 100);

function syncStickyPrice() {
  const selected = document.querySelector('.product-information .mio-tier-option[aria-pressed="true"] [data-mio-total]');
  const price = document.querySelector('[data-mio-sticky-price]');
  if (selected && price) price.textContent = selected.textContent;
}

function shippingBenefit(root, total, baseline) {
  const threshold = Number(root.dataset.offerThreshold);
  const fee = Number(root.dataset.offerFee);
  return threshold > 0 && baseline < threshold && total >= threshold ? fee : 0;
}
function updateShippingNote(root, note, benefit) {
  if (!note) return;
  note.hidden = benefit <= 0;
  note.textContent = ' · ' + (root.dataset.offerNote || '').replace('__amount__', money(benefit, root));
}
function updateTiers(picker) {
  const unit = Number(picker.dataset.unitPrice);
  const threshold = Number(picker.dataset.shippingThreshold);
  picker.querySelectorAll('[data-mio-quantity]').forEach(option => {
    const quantity = Number(option.dataset.mioQuantity);
    const total = Math.round(unit * quantity * (quantity >= 3 ? 90 : 100) / 100);
    option.querySelector('[data-mio-total]').textContent = money(total, picker);
    const each = option.querySelector('[data-mio-each]');
    if (each) each.textContent = money(Math.round(total / quantity), picker);
    const saving = option.querySelector('[data-mio-saving]');
    const benefit = quantity > 1 ? shippingBenefit(picker, total, unit) : 0;
    const saved = unit * quantity - total + benefit;
    if (saving) saving.textContent = money(saved, picker);
    const saveLine = option.querySelector('[data-mio-save-line]');
    if (saveLine) saveLine.hidden = saved <= 0;
    updateShippingNote(picker, option.querySelector('[data-offer-shipping-note]'), benefit);
    const shipping = option.querySelector('[data-mio-free-shipping]');
    if (shipping) shipping.hidden = !(quantity > 1 && threshold > 0 && total >= threshold);
  });
  syncStickyPrice();
}

document.addEventListener('click',event => {
  const option = event.target.closest('[data-mio-quantity]');
  if (!option) return;
  const component = option.closest('product-form-component');
  const input = component?.querySelector('input[name="quantity"]');
  const quantity = Number(option.dataset.mioQuantity);
  if (!input || input.disabled || ![1,2,3].includes(quantity)) return;
  input.value = String(quantity);
  input.dispatchEvent(new Event('input',{bubbles:true}));
  input.dispatchEvent(new Event('change',{bubbles:true}));
  component.dataset.quantityDefault = String(quantity);
  component.querySelectorAll('[data-mio-quantity]').forEach(e=>e.setAttribute('aria-pressed',String(e===option)));
  component.dispatchEvent(new QuantitySelectorUpdateEvent(quantity));
  syncStickyPrice();
});

document.addEventListener(StandardEvents.cartLinesUpdate,event => {
  event.promise?.then(({cart,detail}) => {
    document.querySelectorAll('.mio-tier-picker').forEach(p=>updateTiers(p));
  }).catch(()=>{});
});
document.addEventListener(StandardEvents.productSelect,event => {
  if (event.target.closest('product-card')) return;
  event.promise?.then(({detail}) => {
    const incoming = detail?.html?.querySelector('.mio-tier-picker');
    const picker = document.querySelector('.product-information .mio-tier-picker');
    if (incoming && picker) {picker.dataset.unitPrice=incoming.dataset.unitPrice; updateTiers(picker);}
  }).catch(()=>{});
});

class MiorumiKit extends HTMLElement {
  connectedCallback() {
    if (this.bound) return;
    this.bound = true;
    this.addEventListener('change',()=>this.update());
    this.querySelector('[data-kit-add]').addEventListener('click',()=>this.add());
    this.update();
  }
  items() {
    return [...this.querySelectorAll('[data-kit-variant]')].map(e=>({id:Number(e.value),quantity:1,price:Number(e.tagName==='SELECT'?e.selectedOptions[0].dataset.price:e.dataset.price)}));
  }
  update() {
    const sum=this.items().reduce((n,item)=>n+item.price,0);
    const total=Math.round(sum*90/100);
    this.querySelector('[data-kit-price]').textContent=money(total,this);
    this.querySelector('[data-kit-regular]').textContent=money(sum,this);
    const benefit=shippingBenefit(this,total,this.items()[0]?.price || 0);
    this.querySelector('[data-kit-saving]').textContent=money(sum-total+benefit,this);
    updateShippingNote(this,this.querySelector('[data-offer-shipping-note]'),benefit);
  }
  async add() {
    const button=this.querySelector('[data-kit-add]');
    const error=this.querySelector('[data-kit-error]');
    if (button.disabled) return;
    button.disabled=true;button.setAttribute('aria-busy','true');error.textContent='';
    const items=this.items().map(({id,quantity})=>({id,quantity}));
    const deferred=CartLinesUpdateEvent.createPromise();
    deferred.promise.catch(()=>{});
    this.dispatchEvent(new CartLinesUpdateEvent({action:'add',context:'product',lines:items.map(i=>({merchandiseId:String(i.id),quantity:i.quantity})),promise:deferred.promise}));
    try {
      const root=window.Shopify.routes.root;
      const sections=[...new Set([...document.querySelectorAll('cart-items-component')].map(e=>e.dataset.sectionId).filter(Boolean))];
      const response=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items,sections:sections.join(','),sections_url:location.pathname})});
      const added=await response.json();
      if (!response.ok || added.status) throw new Error(added.description || this.dataset.error);
      const cartResponse=await fetch(root+'cart.js',{headers:{Accept:'application/json'}});
      if (!cartResponse.ok) { location.assign(root+'cart'); return; }
      const cart=await cartResponse.json();
      deferred.resolve({cart:CartLinesUpdateEvent.createCartFromAjaxResponse(cart),detail:{items:cart.items,source:'miorumi-kit',sourceId:this.id,itemCount:3,sections:added.sections,didError:false}});
    } catch (reason) {
      error.textContent=reason.message || this.dataset.error;
      deferred.reject(reason);
    } finally {button.disabled=false;button.removeAttribute('aria-busy');}
  }
}
document.querySelectorAll('.mio-tier-picker').forEach(p=>updateTiers(p));
if (!customElements.get('miorumi-kit')) customElements.define('miorumi-kit',MiorumiKit);

